import { HEADQUARTERS_NAME } from '@speeki/dictionary';

import { CaseOwnerExclusionDocument } from '@graphql/generated/graphql';

import { useQuery } from '@apollo/client';
import { subsidiarySiteVar } from '@boot/reactiveVariables';

export const useCaseOwnerExclusion = () => {
    const { investigationEntity, subsidiarySite } = subsidiarySiteVar() || {};

    const isHeadquarters =
        subsidiarySite?.value === HEADQUARTERS_NAME ||
        investigationEntity === 'HEADQUARTERS';

    return useQuery(CaseOwnerExclusionDocument, {
        context: {
            notifyOnError: true,
        },
        variables:
            !isHeadquarters && subsidiarySite?.value
                ? {
                      input: {
                          subsidiarySiteUuid: subsidiarySite?.value,
                      },
                  }
                : undefined,
    });
};
